module.exports = __webpack_public_path__ + "img/outcome_02.aa87eadc.jpg";